module.exports = __webpack_public_path__ + "img/btn-jt-2.32528b41.png";